import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import type { PlannedSquadPayload } from '../lib/api';

interface DuelState {
  entryA: string;
  entryB: string;
  nicknameA: string;
  nicknameB: string;
  leagueId: string;
  plannedA: PlannedSquadPayload | null;
  setEntryA(value: string): void;
  setEntryB(value: string): void;
  setNicknameA(value: string): void;
  setNicknameB(value: string): void;
  setLeagueId(value: string): void;
  setPlannedA(value: PlannedSquadPayload | null): void;
}

export const useDuelStore = create<DuelState>()(
  persist(
    (set) => ({
      entryA: '',
      entryB: '',
      nicknameA: 'Bram',
      nicknameB: 'Viktor',
      leagueId: '',
      plannedA: null,
      setEntryA: (entryA) => set({ entryA }),
      setEntryB: (entryB) => set({ entryB }),
      setNicknameA: (nicknameA) => set({ nicknameA }),
      setNicknameB: (nicknameB) => set({ nicknameB }),
      setLeagueId: (leagueId) => set({ leagueId }),
      setPlannedA: (plannedA) => set({ plannedA }),
    }),
    { name: 'bramx-pro-control-v036' },
  ),
);
